import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {IQrefPrpod5599 as dictionaryInterface} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-prpod5599',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefPrpod5599ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         name="briefdesc"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [multiple]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['briefdesc','code']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <div style="white-space: normal">
            <b> {{ item.code }} </b>
          </div>
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            <b> {{ item.code }} </b>
            {{ item.briefdesc }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefPrpod5599ViewComponent extends ViewDictionaryBase<dictionaryInterface> {
  getDictionary = this.dictSrv.getQrefPrpod5599List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
